import { BASE_INPUT_DEFAULT_DISABLE, BASE_INPUT_DEFAULT_MODE, BASE_INPUT_DEFAULT_ROLE, BASE_INPUT_DEFAULT_SIZE } from '../../common/BaseInput/BaseInput.constants';
// Constants.
// -----------------------------------------------------------------------------
/** Default disabled */
export const TEXTAREA_DEFAULT_DISABLED = BASE_INPUT_DEFAULT_DISABLE;
/** Default mode. */
export const TEXTAREA_DEFAULT_MODE = BASE_INPUT_DEFAULT_MODE;
/** Default number of Text Area rows. */
export const TEXTAREA_DEFAULT_ROWS = 5;
/** Default size. */
export const TEXT_AREA_DEFAULT_SIZE = BASE_INPUT_DEFAULT_SIZE;
/** Default role. */
export const TEXT_AREA_DEFAULT_ROLE = BASE_INPUT_DEFAULT_ROLE;
//# sourceMappingURL=TextArea.constants.js.map